<template>
    <div>
        <div class="d-flex align-center justify-center">
            <v-timeline :class="!verMais ? 'mb-16' : 'mb-6'">
                <v-timeline-item
                    v-for="(item, index) in ajustes"
                    :key="item.id"
                    :color="retornaCorTimeline(item)"
                    fill-dot small>
                    <template v-slot:opposite>
                        <span class="text-left text--darken-1 grey--text text-body-2">{{item.dataFinalizacao | azDate('DD/MM/YYYY')}}</span>
                    </template>

                    <template v-slot:icon>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="white" size="16">
                              {{retornaIcone(item)}}
                          </v-icon>
                        </template>
                        <span>{{item.situacao | azEnum(situacoesLinhaTempoAjuste)}}</span>
                      </v-tooltip>
                    </template>

                    <v-card color="mx-auto"  width="600" class="bordaPrincipal">
                        <v-row class="ml-2 gap-5 pa-0" :class="{'reverse-card': verificaLadoCard(index)}">
                            <v-col cols="2" class="siglaCol pa-0 pt-2">
                                <v-tooltip top nudge-top="-3" max-width="800" open-delay="500">
                                    <template v-slot:activator="{ on }">
                                        <div v-on="on" class="iconeCard d-flex justify-center align-center">
                                            <span class="textoTitulo">A</span>
                                        </div>
                                    </template>
                                    <span>Ajuste</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="9">
                                <div class="d-flex flex-column">
                                    <span class="tituloCard text--darken-1 primary--text">{{ item.tipo }}</span>
                                    <v-card-text class="text-left informacoesValores text--darken-1 grey--text">
                                        <span class="font-weight-bold">De: </span>{{item.valorLiquidoAnterior | valorParaDinheiro }}<br/>
                                        <span class="font-weight-bold">Para: </span>{{item.valorLiquidoPosterior| valorParaDinheiro }}<br/>
                                    </v-card-text>
                                </div>
                            </v-col>
                        </v-row>

                        <v-divider></v-divider>
                        <v-card-actions class="pa-0 px-3">
                            <v-flex>
                                <v-row>
                                    <v-btn color="primary" text width="49%" class="text-body-4"
                                    @click="abrirModalMaisDetalhes(item)">
                                        Mais Detalhes
                                    </v-btn>
                                    <v-divider vertical></v-divider>
                                    <v-btn color="primary" text width="49%" class="text-body-4" @click="acessarVisualizacao(item)">
                                        Acessar
                                        <v-icon class="ml-2" size="14">fas fa-external-link-alt</v-icon>
                                    </v-btn>
                                </v-row>
                            </v-flex>
                        </v-card-actions>
                    </v-card>

                </v-timeline-item>
            </v-timeline>
        </div>
        <div class="d-flex align-center justify-center pb-16" v-if="verMais">
            <v-btn color="primary" class="call-to-action text-body-2" @click="verMaisLinhaDoTempo">
                Ver Mais
            </v-btn>
        </div>
    </div>
</template>

<script>

    import situacoesLinhaTempoAjuste from '@/core/constants/situacoesLinhaTempoAjuste'

    export default {
        name: 'LinhaDoTempoAjuste',
        props: ['items','orgaos'],
        data() {
            return {
                verMais: false,
                ajustes: [],
                situacoesFinalizado: ['FINALIZADO']
            }
        },
        computed: {
            situacoesLinhaTempoAjuste() {
                return situacoesLinhaTempoAjuste
            },
            ajustesMaiorQueCinco() {
                return this.items.length > 5
            },
        },
        watch: {
            'items'() {
                this.formatarLinhaDoTempo()
            }
        },
        mounted() {
            this.$gtag.event('MovimentacoesLinhaTempo', { method: 'Google' })
            this.formatarLinhaDoTempo()
        },
        methods: {
            erroProcessamento(itemAjuste) {
                return itemAjuste.situacao === 'ERRO_PROCESSAMENTO'
            },
            verMaisLinhaDoTempo() {
                this.ajustes = this.items
                this.verMais = false
            },
            verificaLadoCard(index) {
                return index % 2 === 0
            },
            async formatarLinhaDoTempo() {
                this.verMais = false
                this.ajustes = this.items
                if (this.ajustesMaiorQueCinco) {
                    this.ajustes = this.items.slice(0, 5)
                    this.verMais = true
                }
            },
            abrirModalMaisDetalhes(item) {
                this.$emit('abrirModalMaisDetalhes', item)
            },
            acessarVisualizacao(item) {
                this.$emit('acessarVisualizacao', item)
            },
            retornaIcone(item) {
                if (this.situacoesFinalizado.includes(item.situacao)) {
                    return 'done'
                }
                return 'priority_high'
            },
            retornaCorTimeline(item) {
                return item.situacao === 'ERRO_PROCESSAMENTO' ? '#f9a825' : 'primary'
            },
        }
    }
</script>


<style lang="stylus">
    .bordaPrincipal
        box-sizing border-box
        border-bottom 0 !important


    .max-10
        max-width 10vw

    .iconeCard
        border-radius 50%
        height 45px
        width 45px
        background-color: #D9D9D9

    .reverse-card
        flex-direction row-reverse
        padding-left: 8px
        justify-content flex-end
        background-color: purlple

    .tituloCard
        font-weight bold
        font-size 0.90em
        max-width: 300px
        display: block
        overflow hidden
        text-overflow ellipsis
        white-space nowrap

    .warningText
        color: #f9a825

    .informacoesValores
        font-size: .80em
        padding: 0

    .siglaCol
        align-content: center
        cursor: default


</style>
